export default (builder) =>
  builder.query({
    query: () => ({
      url: `/unlisted-companies`,
      method: 'GET',
    }),
    providesTags: ['report-sources', 'preferences'],
  });
